import { Controller } from '@hotwired/stimulus'
import CSVExport from '../app/modules/csv_export'

// Handles ClickHouse Call log CSV export with progress/polling + auto-download.
export default class extends Controller {
    static values = {
        params: Object,
    }

    connect() {
        this.exporter = new CSVExport({
            title: 'calls',
            button: this.element,
            remote: true,
            route: '/reports/calls_clickhouse',
            params: this.paramsValue || {},
        })
    }

    export(event) {
        event.preventDefault()
        if (!this.exporter) return
        // Give immediate feedback: disable, start spinner, and kick off the export
        this.exporter.createLadda()
        this.exporter.laddaStart()
        this.exporter.downloadRemote()
    }
}
